import { useFormikContext } from "formik";
import React, { useState } from "react";
import { FaToggleOff, FaToggleOn } from "react-icons/fa";

const ToggleField = ({ text, name,value,toggaleHandleChange,disabled }) => {
  const { setFieldValue } = useFormikContext();

  const [toggle, setToggle] = useState(value);

  const handleClick = (e) => {
    if (!disabled) {    
      e.target.name=name
      e.target.value=!toggle
      setToggle(!toggle);
      toggle ? setFieldValue(name, false) : setFieldValue(name, true);
      toggaleHandleChange && toggaleHandleChange(e)
    }
  };

  // console.log("toggle",toggle);
  

  return (
    <label
      className="flex gap-2 cursor-pointer "
      htmlFor="toggle"
      onClick={handleClick}
    >
      {toggle ? (
        <FaToggleOn className=" hover:text-hoverColor text-xl" id="toggle" />
      ) : (
        <FaToggleOff className=" hover:text-hoverColor text-xl" id="toggle" />
      )}
      {text}
    </label>
  );
};

export default ToggleField;
